import { render, staticRenderFns } from "./sequenceFlow.vue?vue&type=template&id=15232a0e&"
import script from "./sequenceFlow.vue?vue&type=script&lang=js&"
export * from "./sequenceFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports